import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import Typography from '../../foundations/Typography';
import { Col, Row } from '../../foundations/Grid';
import Link from '../../components/Link';

export const DocumentLinkStyled = styled.div`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      position: relative;
      min-height: ${mediumUp ? rem(100) : rem(90)};
      width: 100%;
      transition: ${theme.effects.shadows.transition};
      background-color: ${theme.colors.neutral.grayLight30};
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: ${rem(6)};
      &:hover {
        box-shadow: ${theme.effects.shadows.hover};
        text-decoration: none;
        cursor: pointer;
      }
    `;
  }
}`;

export const RowStyled = styled(Row)`
  align-items: center;
  min-height: ${rem(70)};
  padding: ${rem(20)} 0;
`;

export const ColIconStyled = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: ${rem(70)};
  .nmx-icon {
    width: 100%;
    height: 100%;
  }
`;

export const ColPictureStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding-left: ${mediumUp ? rem(20) : rem(15)};
      display: flex;
      align-items: center;
      justify-content: center;
      height: ${rem(80)};
    `;
  }
}`;

export const ImageContainerStyled = styled.div`
  ${({ backgroundImage }) => css`
    width: 100%;
    height: 100%;
    background-image: url('${backgroundImage}');
    background-position: center;
    background-size: cover;
  `}
`;

export const ColLinkStyled = styled(Col)`
  display: flex;
  padding-left: 0;
  align-items: center;
`;

export const LinkStyled = styled(Link)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const TypographyStyled = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: 0;
    padding-top: ${rem(-2)};
    padding-right: ${rem(30)};
    padding-bottom: 0;
    color: ${theme.colors.neutral.grayDark20};
    font-weight: 500;
    &.hover-state-active {
      color: ${theme.colors.action.lightTheme.linkHover}; /** changed from linkDefault to linkHover - Confirm with Creative */
    }
  `}
`;
